package one.healthium.ui.compose.components

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.progressSemantics
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.CornerRadius
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.DrawScope
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_2

@Composable
fun AppLinearProgressIndicator(
    modifier: Modifier = Modifier,
    color: Color = AppTheme.colors.primary,
    trackColor: Color = gray_2,
    progress: () -> Float,
) {
    val coercedProgress = { progress().coerceIn(0f, 1f) }

    Canvas(
        modifier = modifier.height(16.dp).progressSemantics(coercedProgress())
    ) {
        drawLinearIndicatorTrack(trackColor)
        drawLinearIndicator(coercedProgress(), color)
    }
}

private fun DrawScope.drawLinearIndicatorTrack(
    color: Color,
) = drawLinearIndicator(1f, color)

private fun DrawScope.drawLinearIndicator(
    fraction: Float,
    color: Color,
) {
    val halfHeight = size.height / 2

    drawRoundRect(
        color = color,
        size = Size(size.width * fraction, size.height),
        cornerRadius = CornerRadius(halfHeight, halfHeight),
    )
}
